import React from 'react'

import TopicImg from '../../i/topic_img.svg';

export const Topic = ({ name, descr }) => {
	return (
		<div className="topic_item">
			<div className="topic_img_w">
				<TopicImg className="topic_img" />
			</div>
			<h3 className="topic_title">{name}</h3>
			<div className="topic_text">{descr}</div>
		</div>
	);
}
export default Topic;

